import HttpMethod from '../../services/httpMethods'
import { ApiResponse } from '../../services/types';
import { makeRequest } from '../../services/restcall';


export async function putUpdatePasswordUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/update/password',value)
}
export async function getValidateTokenAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/validate/token?token='+value,{})
}

export async function getCIE10ByFilterAPI(filter:string, value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/cie10?filter='+ filter +'&value='+value, {})
}

export async function getStatusOrganizationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-status?tenant='+process.env.REACT_APP_CODE_TENANT,{})
}


export async function getPathologicalHistoryAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/pathological-history',value)
}
export async function getUserInfoByTokenAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/userinformationtoken',value)
}

export async function getUserOdontologicoAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/odontologos',{})
}
export async function getUserAssociatedAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/associated',{})
}

export async function updatepasswordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/updatepassword',value)
}

export async function getRecoverPasswordAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/recoverpassword?dni='+value,{})
}

export async function getActiveSpecialityAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/speciality',{})
}

export async function getActiveGroupAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/group?type='+value,{})
}


export async function getGroupModuleAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/group-module',{})
}

export async function postLoginAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/login',value)
}

export async function getAllModuleTokenWithUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/module-token', value)
}

export async function getAllTableUserAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/user',{})
}
export async function updateUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/user',value)
}

export async function updateStatusUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/user/status',value)
}
export async function postRegisterUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/user',value)
}